import { CONTACTS, URLS } from './constants/';

export { CONTACTS, URLS };
